import { paths } from "../paths.js";
import { makeSession } from "./session.js";
import { makeAuthRepo } from "./auth.repo.js";
import { makeUserProfileRepo } from "./userProfile.repo.js";
import { makeFriendRepo } from "./friend.repo.js";
import { makeManagedProfileRepo } from "./managedProfile.repo.js";
import { makeTripRepo } from "./trip.repo.js";
import { makeNoteRepo } from "./note.repo.js";
import { makeCategoryRepo } from "./category.repo.js";
import { makeItemRepo } from "./item.repo.js";
import { makeTodoRepo } from "./todo.repo.js";
import { makeTemplateRepo } from "./template.repo.js";
import { makeSharingRepo } from "./sharing.repo.js";
import { makeConnectivity } from "./connectivity.repo.js";
import { makeCopyApplier, makeImportApplier, makeParticipantRemovalApplier, makeTemplateRemovalApplier, makeTemplateSyncApplier, } from "./importApplier.js";
// The composition root for the Firebase backend — the one place concrete Firestore
// repositories are wired to the Domain interfaces. The same `AllRepositories` shape
// the in-memory fakes satisfy, so it drops into the contract suite unchanged.
export const makeFirebaseRepos = (handles) => {
    const { db, auth, functions } = handles;
    const p = paths(db);
    // A live mirror of the acting user, kept current for repos that need "who am I".
    const { session, set } = makeSession();
    const authRepo = makeAuthRepo(auth, db, p);
    authRepo.observeCurrentUser().subscribe((u) => set(u));
    return {
        auth: authRepo,
        profiles: makeUserProfileRepo(db, p, session, auth),
        friends: makeFriendRepo(db, p, session, functions),
        managed: makeManagedProfileRepo(db, p, session, functions),
        trips: makeTripRepo(db, p, session),
        notes: makeNoteRepo(db, p),
        categories: makeCategoryRepo(db, p),
        items: makeItemRepo(db, p),
        todos: makeTodoRepo(db, p),
        templates: makeTemplateRepo(db, p, session),
        sharing: makeSharingRepo(db, p, session, functions),
        connectivity: makeConnectivity(),
        // The import seam the composition roots probe for (see TemplatesForTripModal):
        // applies a T05 ImportPlan as one optimistic Firestore batch.
        applyImportPlan: makeImportApplier(db, p),
        // Sync back (Doc 13 §5): awaits its chunked commits and reports, unlike the
        // fire-and-forget import above.
        applyTemplateSyncPlan: makeTemplateSyncApplier(db, p),
        // Issue #8 — duplicate a template / build one from a trip / copy a trip: awaits
        // and chunks like the sync applier above.
        applyCopyPlan: makeCopyApplier(db, p),
        // Issue #185 — deletes/re-assigns the rows a departing traveler leaves behind.
        applyParticipantRemovalPlan: makeParticipantRemovalApplier(db, p),
        // "Remove template from trip" — scoped to a single trip's rows.
        applyTemplateRemovalPlan: makeTemplateRemovalApplier(db, p),
    };
};
//# sourceMappingURL=index.js.map